import { Person, Settings } from '@mui/icons-material';
import { ListItemButton, ListItemIcon, ListItemText, SvgIcon } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RouterLink } from 'src/components/router-link';
import useCurrentUser from 'src/hooks/use-current-user';
import { useStopwatch } from 'src/layouts/check-in-checkout/StopwatchContext';
import { paths } from 'src/paths';
import { postTimeCheckOutAction } from 'src/redux/actions/therapist-dashboard-action';
import { logoutUser } from 'src/routes/AuthContext';

interface AccountPopoverProps {
  anchorEl: null | Element;
  onClose?: () => void;
  open?: boolean;
}

export const AccountPopover: FC<AccountPopoverProps> = (props) => {
  const { anchorEl, onClose, open, ...other } = props;
  const dispatch = useDispatch();
  const { globalLocationType, setIsRunning } = useStopwatch();
  const user = useSelector((state: any) => state.getTherapistProfileReducer?.response?.data);
  const [providerId] = useCurrentUser(['providerId']);

  const getTimeCheckIn = useSelector((state: any) => state.checkInReducer);
  const getResponseOfCheckout = useSelector((state: any) => state.checkoutReducer);

  const handleLogout = (e: any) => {
    e.preventDefault();
    setIsRunning(false);
    localStorage.setItem('isCheckIn', 'false');
    localStorage.removeItem('isCheckIn');
    localStorage.removeItem('lastRunningTime');
    // if (
    //   getResponseOfCheckout?.response !== null &&
    //   getResponseOfCheckout?.response?.data?.requestedTimerStatus === 'CLOCK_IN'
    // ) {
    //   const currentTime = new Date().toISOString();
    //   dispatch(
    //     postTimeCheckOutAction({
    //       providerId,
    //       date: currentTime,
    //       timer: 'CLOCK_OUT',
    //       clockId: getTimeCheckIn?.withPersistResponse?.data?.uuid,
    //       isLogout: true,
    //       idleTimeExpired: false,
    //       clockInBody: {
    //         locationType: globalLocationType,
    //         payByMilage: null,
    //       },
    //     })
    //   );
    //   return;
    // } else {
    logoutUser();
    // }
  };

  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
      disableScrollLock
      onClose={onClose}
      open={!!open}
      PaperProps={{ sx: { width: 200 } }}
      {...other}
    >
      {user?.currentPermissions?.includes('Physician Dashboard') ? (
        <>
          <Box sx={{ p: 2 }}>
            <Typography variant="body1">{`${user?.firstName
              ?.toUpperCase()
              .charAt(0)}${user?.firstName?.slice(1)}`}</Typography>
            <Typography
              color="text.secondary"
              variant="body2"
            >
              {user?.email || ''}
            </Typography>
          </Box>
        </>
      ) : (
        user?.firstName &&
        user?.lastName && (
          <Box sx={{ p: 2 }}>
            <Typography variant="body1">{`${user?.lastName
              ?.toUpperCase()
              .charAt(0)}${user?.lastName?.slice(1)} ${user?.firstName
              ?.toUpperCase()
              .charAt(0)}${user?.firstName?.slice(1)}`}</Typography>
            <Typography
              color="text.secondary"
              variant="body2"
            >
              {user?.email || ''}
            </Typography>
          </Box>
        )
      )}

      <Divider />
      <Box sx={{ p: 1 }}>
        {/* <ListItemButton
          component={RouterLink}
          href="#"
          onClick={onClose}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <Person />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1">Profile</Typography>} />
        </ListItemButton> */}
        <ListItemButton
          component={RouterLink}
          href={paths.postAuthResetPassword}
          sx={{
            borderRadius: 1,
            px: 1,
            py: 0.5,
          }}
        >
          <ListItemIcon>
            <SvgIcon fontSize="small">
              <Settings />
            </SvgIcon>
          </ListItemIcon>
          <ListItemText primary={<Typography variant="body1">Reset Password</Typography>} />
        </ListItemButton>
      </Box>
      <Divider sx={{ my: '0 !important' }} />
      <Box
        sx={{
          display: 'flex',
          p: 1,
          justifyContent: 'center',
        }}
      >
        <Button
          // color="inherit"
          onClick={(e) => handleLogout(e)}
          fullWidth
          size="small"
          type="button"
          variant="outlined"
        >
          Logout
        </Button>
      </Box>
    </Popover>
  );
};
